"use strict";

const IncidentInvestigationValidator = function () {
  var getMissingRequiredFields = function (data) {
    return FormValidator.getEmptyRequiredFieldsInData(data, getRequiredFields(data));
  };

  var getRequiredFields = function (data) {
    const isFollowUpInformal = data.investigationType === "follow-up-informal";

    const fields = [
      { fieldName: "start-time", message: "Investigation date & start time" },
      { fieldName: "end-time", message: "Investigation end date & time" },
      { fieldName: "signatures[inspectorName]", message: "Inspector name" },
      { fieldName: "signatures[inspectorEsignature]", message: "Inspector signature" },
    ];

    if (!data.closeOutInvestigation) {
      fields.push({ fieldName: "follow-up-inspection-type", message: "Follow up type" });
      fields.push({ fieldName: "follow-up-date", message: "Follow up due date" });
    }

    if (!isFollowUpInformal) {
      fields.push({
        fieldName: "isSiteRepPresent",
        message: "Is the site representative on site",
      });

      if (data.isSiteRepPresent === true) {
        fields.push({
          fieldName: "signatures[siteRepDate]",
          message: "Site representative signature date",
        });
        fields.push({
          fieldName: "signatures[siteRepName]",
          message: "Site representative name",
        });
        fields.push({
          fieldName: "signatures[siteRepEsignature]",
          message: "Site representative signature",
        });
      }
    }

    const responsiblePartyIdentified =
      data.responsiblePartyIdentified ?? data.incidentInfo?.responsiblePartyIdentified;
    if (responsiblePartyIdentified === true) {
      fields.push({
        fieldName: "flagEnforcement",
        message: "Flag for new enforcement",
      });
    }

    return fields;
  };

  return {
    getMissingRequiredFields,
  };
};

module.exports = IncidentInvestigationValidator();

const FormValidator = require("../../general/formValidator");
